module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"HEDEFLER","goalCountColumn":"Hedef Sayısı","approvedGoalCountColumn":"Onaylanan Hedef Sayısı"},"en":{"title":"GOALS","goalCountColumn":"Goals","approvedGoalCountColumn":"Approved Goals"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Goal/Summary.vue
// module id = fnqN
// module chunks = 1